import Layout from '@/layout'
const _import = path => () => import(`@/views/${path}`)

const asyncRoutes = [
  // 组织架构
  {
    path: '/org',
    component: Layout,
    name: '1001',
    meta: { type: '1001', title: '1001', icon: 'org', permission: ['menu.org'] },
    children: [
      // 部门架构
      {
        path: 'dep',
        name: '/org/dep',
        component: _import('org/dep'),
        meta: {
          module: '/org/dep,1001',
          type: '/org/dep',
          title: '1002',
          permission: ['menu.org.dep']
        }
      },
      // 职位
      {
        path: 'position',
        name: '/org/position',
        component: _import('org/position'),
        meta: {
          module: '/org/position,1001',
          type: '/org/position',
          title: '4',
          permission: ['menu.org.position']
        }
      }
    ]
  },
  // 员工管理
  {
    path: '/staff',
    name: 'staff',
    component: Layout,
    meta: { type: 'staff', title: '666', icon: 'clock', permission: ['menu.staff'] },
    alwaysShow: true,
    children: [
      // 员工信息
      {
        path: 'per',
        name: '/staff/per',
        component: _import('staff/per'),
        meta: {
          module: '/staff/per,staff',
          type: '/staff/per',
          title: '3',
          permission: ['menu.org.per']
        }
      },
      // 转正管理
      {
        path: 'pemploymenter',
        name: '/staff/pemploymenter',
        component: _import('staff/pemploymenter'),
        meta: {
          title: 'invite_44',
          module: '/staff/pemploymenter,staff',
          type: '/staff/pemploymenter',
          permission: ['menu.staff.pemploymenter']
        }
      },
      {
        path: 'pemploymenter/setting',
        name: '/staff/pemploymenter/setting',
        component: _import('dashboard/index'),
        meta: {
          title: 'invite_15',
          module: '/staff/pemploymenter,staff',
          type: '/staff/pemploymenter',
          isHide: true
        }
      },
      // 离职管理
      {
        path: 'quit',
        name: '/staff/quit',
        component: _import('staff/quit-manger'),
        meta: {
          module: '/staff/quit,staff',
          type: '/staff/quit',
          title: '967',
          permission: ['menu.staff.quit']
        }
      }
    ]
  },
  // 考勤管理
  {
    path: '/Attendance',
    name: 'Attendance',
    redirect: { name: 'clock' },
    component: Layout,
    meta: { type: 'Attendance', title: '523', icon: 'table', permission: ['menu.work'] },
    children: [
      // 打卡设置
      {
        path: 'clock',
        name: '/Attendance/clock',
        component: _import('Attendance/clock'),
        meta: {
          module: '/Attendance/clock,Attendance',
          type: '/Attendance/clock',
          title: '524',
          permission: ['menu.work.clock']
        }
      },
      // 班次设置
      {
        path: 'frequency',
        name: '/Attendance/frequency',
        component: _import('Attendance/frequency'),
        meta: {
          module: '/Attendance/frequency,Attendance',
          type: '/Attendance/frequency',
          title: '1360',
          permission: ['menu.work.frequency']
        }
      },
      // 人脸信息
      {
        path: 'staff',
        name: '/Attendance/staff',
        component: _import('Attendance/clock/staff'),
        meta: {
          module: '/Attendance/staff,Attendance',
          type: '/Attendance/staff',
          title: '915',
          permission: ['menu.person']
        }
      },
      // 规则设置
      {
        path: 'rule',
        name: '/Attendance/rule',
        component: _import('Attendance/rule'),
        meta: {
          module: '/Attendance/rule,Attendance',
          type: '/Attendance/rule',
          title: 'work_rule_1',
          permission: ['menu.work.rule']
        }
      },
      // 考勤统计
      {
        path: 'statistics',
        name: '/Attendance/statistics',
        component: _import('Attendance/statistics'),
        meta: {
          module: '/Attendance/statistics,Attendance',
          type: '/Attendance/statistics',
          title: '1944',
          permission: ['menu.statistics']
        }
      },
      // 月度汇总
      {
        path: 'monthly-statistics',
        name: '/Attendance/monthly-statistics',
        component: _import('Attendance/monthly-statistics'),
        meta: {
          module: '/Attendance/monthly-statistics,Attendance',
          type: '/Attendance/monthly-statistics',
          title: '1930',
          permission: ['menu.monthly-statistics']
        }
      },
      // 打卡记录
      {
        path: 'punch-record',
        name: '/Attendance/punch-record',
        component: _import('Attendance/punch-record'),
        meta: {
          module: '/Attendance/punch-record,Attendance',
          type: '/Attendance/punch-record',
          title: 'i18n.b553a35f11054343a2e9e60a97266006',
          permission: ['menu.work.punch-record']
        }
      }
    ]
  },
  // 审批管理
  {
    path: '/approval',
    component: Layout,
    name: '87',
    meta: { type: '87', title: '87', icon: 'tree', permission: ['menu.approval'] },
    children: [
      // 数据查询
      {
        path: 'search',
        name: '/approval/search',
        component: _import('approval/search'),
        meta: {
          module: '/approval/search,87',
          type: '/approval/search',
          title: '88',
          permission: ['menu.approval.search']
        }
      },
      // 审批管理
      {
        path: 'config',
        name: '/approval/config',
        component: _import('approval/config'),
        meta: {
          module: '/approval/config,87',
          type: '/approval/config',
          title: 'work_rule_3',
          permission: ['menu.approval.config']
        }
      },
      // 审批管理
      {
        path: 'lang',
        name: '/approval/lang',
        component: _import('approval/config/setting/form/lang'),
        meta: {
          module: '/approval/config,87',
          type: '/approval/config',
          title: 'work_rule_3',
          permission: ['menu.approval.config'],
          isHide: true
        }
      },
      // 新增审批流
      {
        path: 'addSetting',
        name: '/approval/addSetting',
        component: _import('approval/config/setting'),
        meta: {
          module: '/approval/config,87',
          type: '/approval/config',
          title: 'work_rule_11'
        },
        hidden: true
      },
      // 编辑审批流
      {
        path: 'editSetting',
        name: '/approval/editSetting',
        component: _import('approval/config/setting'),
        meta: {
          module: '/approval/config,87',
          type: '/approval/config',
          title: 'work_rule_12'
        },
        hidden: true
      }
    ]
  },
  // 消息
  {
    path: '/tool',
    component: Layout,
    name: '914',
    meta: { type: '914', title: '914', icon: 'example', permission: ['menu.tool'] },
    children: [
      {
        path: 'message',
        name: '/tool/message',
        component: _import('tool/message'),
        meta: {
          // module: '914',
          type: '/tool/message',
          title: '203',
          permission: ['menu.tool.message']
        }
      }
      // 操作记录
      //,
      // {
      //   path: 'record',
      //   name: '/tool/record',
      //   component: _import('tool/record'),
      //   meta: {
      //     title: '302',
      //     icon: 'record',
      //     permission: ['menu.tool.record']
      //   }
      // }
    ]
  },
  // 薪酬计算
  {
    path: '/payroll',
    name: 'payroll',
    component: Layout,
    meta: {
      type: 'payroll',
      title: '379',
      icon: 'money',
      permission: ['menu.payroll']
    },
    children: [
      // 员工薪资
      {
        path: 'salary',
        name: '/payroll/salary',
        component: _import('payroll/salary'),
        meta: {
          module: '/payroll/salary,payroll',
          type: '/payroll/salary',
          title: '913',
          permission: ['menu.payroll.salary']
        }
      },
      {
        path: 'salaryRecord/:staff_id',
        name: '/payroll/salaryRecord',
        component: _import('payroll/salary/record'),
        meta: {
          module: '/payroll/salary,payroll',
          type: '/payroll/salary',
          title: '871',
          permission: ['menu.payroll.salary'],
          isHide: true
        }
      },
      {
        path: 'salaryHistory/:staff_id',
        name: '/payroll/salaryHistory',
        component: _import('payroll/salary/history'),
        meta: {
          module: '/payroll/salary,payroll',
          type: '/payroll/salary',
          title: 'i18n.8332aec5e5f2411f802b111838a71072',
          permission: ['menu.payroll.salary'],
          isHide: true
        }
      },
      {
        path: 'salaryBatch',
        name: '/payroll/salaryBatch',
        component: _import('payroll/salary/batch'),
        meta: {
          module: '/payroll/salary,payroll',
          type: '/payroll/salary',
          title: 'i18n.5a6653a1d4ea4108ab13f868622bd90a',
          permission: ['menu.payroll.salary'],
          isHide: true
        }
      },
      // {
      //   path: 'management',
      //   name: '/payroll/management',
      //   component: _import('payroll/management'),
      //   meta: {
      //     module: '/payroll/management,payroll', // 薪酬计算
      //     type: '/payroll/management', // 薪资项目
      //     title: 'payroll_management_1',
      //     permission: ['menu.payroll.management']
      //     // activeMenu: 'management'
      //   }
      // },
      {
        path: 'items',
        name: '/payroll/items',
        component: _import('payroll/items'),
        meta: {
          module: '/payroll/items,payroll',
          type: '/payroll/items',
          title: 'payroll_management_1',
          permission: ['menu.payroll.management']
        }
      },
      {
        path: 'items/fixed',
        name: '/payroll/items/fixed',
        component: _import('payroll/items/fix-and-unfix'),
        meta: {
          module: '/payroll/items,payroll',
          type: '/payroll/items',
          title: 'meta.title.fixed',
          permission: ['menu.payroll.management'],
          isHide: true
        }
      },
      {
        path: 'items/unfixed',
        name: '/payroll/items/unfixed',
        component: _import('payroll/items/fix-and-unfix'),
        meta: {
          module: '/payroll/items,payroll',
          type: '/payroll/items',
          title: 'meta.title.unfixed',
          permission: ['menu.payroll.management'],
          isHide: true
        }
      },
      {
        path: 'items/import',
        name: '/payroll/items/import',
        component: _import('payroll/items/import'),
        meta: {
          module: '/payroll/items,payroll',
          type: '/payroll/items',
          title: 'meta.title.import',
          permission: ['menu.payroll.management'],
          isHide: true
        }
      },
      {
        path: 'items/other',
        name: '/payroll/items/other',
        component: _import('payroll/management/detail'),
        meta: {
          module: '/payroll/items,payroll',
          type: '/payroll/items',
          title: 'payroll_management_51',
          permission: ['menu.payroll.management'],
          isHide: true
        }
      },
      // 记薪方案
      {
        path: 'salary-scheme',
        name: '/payroll/salary-scheme',
        component: _import('payroll/salary-scheme'),
        meta: {
          module: '/payroll/salary-scheme,payroll',
          type: '/payroll/salary-scheme',
          permission: ['menu.payroll.payroll_scheme'],
          title: '1110'
        }
      },
      {
        path: 'salary-edit/:id',
        name: '/payroll/salary-edit',
        component: _import('payroll/salary-scheme/detail'),
        meta: {
          module: '/payroll/salary-scheme,payroll',
          type: '/payroll/salary-scheme',
          title: 'payroll_salary_1',
          isHide: true
        }
      },
      // 工资计算
      {
        path: 'wage',
        name: '/payroll/wage',
        component: _import('payroll/wage'),
        meta: {
          module: '/payroll/wage,payroll',
          type: '/payroll/wage',
          title: '380',
          permission: ['menu.payroll.wage']
        }
      },
      {
        path: 'wage/list',
        name: '/payroll/wage/list',
        component: _import('payroll/wage/list'),
        meta: {
          module: '/payroll/wage,payroll',
          type: '/payroll/wage',
          title: 'payroll_wage_12',
          permission: ['menu.payroll.wage'],
          isHide: true
        }
      },
      {
        path: 'wageModal/:id',
        name: '/payroll/wageModal/id',
        component: _import('payroll/wage/modal'),
        meta: {
          module: '/payroll/wage,payroll',
          type: '/payroll/wage',
          title: 'payroll_salary_25',
          permission: ['menu.payroll.wage'],
          isHide: true
        }
      },
      {
        path: 'wageModal',
        name: '/payroll/wageModal',
        component: _import('payroll/wage/modal'),
        meta: {
          module: '/payroll/wage,payroll',
          type: '/payroll/wage',
          title: 'payroll_wage_11',
          permission: ['menu.payroll.wage'],
          isHide: true
        }
      },
      {
        path: 'wageSalary/:id',
        name: '/payroll/wageSalary',
        component: _import('payroll/wage/salary'),
        meta: {
          module: '/payroll/wage,payroll',
          type: '/payroll/wage',
          title: 'payroll_wage_10',
          permission: ['menu.payroll.wage'],
          isHide: true
        }
      },
      {
        path: 'pay-slip',
        name: '/payroll/pay-slip',
        component: _import('payroll/pay-slip'),
        meta: {
          module: '/payroll/pay-slip,payroll',
          type: '/payroll/pay-slip',
          title: '1021',
          permission: ['menu.payroll.scheme']
        }
      },
      // 创建工资条
      {
        path: 'edit-pay-slip',
        name: 'creat-pay-slip',
        component: _import('payroll/pay-slip/edit-pay-slip'),
        meta: {
          module: '/payroll/pay-slip,payroll',
          type: '/payroll/pay-slip',
          title: 'pay_slip_4',
          permission: ['menu.payroll.scheme'],
          isHide: true
        }
      },
      // 编辑工资条
      {
        path: 'edit-pay-slip/:schemeId',
        name: 'edit-pay-slip',
        component: _import('payroll/pay-slip/edit-pay-slip'),
        meta: {
          module: '/payroll/pay-slip,payroll',
          type: '/payroll/pay-slip',
          title: '1083',
          permission: ['menu.payroll.scheme'],
          isHide: true
        }
      },
      // 发送工资条
      {
        path: 'paywages-pay-slip/:subProjectId',
        name: 'paywages-pay-slip',
        component: _import('payroll/pay-slip/edit-pay-slip'),
        meta: {
          module: '/payroll/pay-slip,payroll',
          type: '/payroll/pay-slip',
          title: 'pay_slip_2',
          permission: ['menu.payroll.scheme'],
          isHide: true
        }
      },
      {
        path: 'setpay-pay-slip/:subProjectId',
        name: 'setpay-pay-slip',
        component: _import('payroll/pay-slip/edit-pay-slip'),
        meta: {
          module: '/payroll/pay-slip,payroll',
          type: '/payroll/pay-slip',
          title: 'pay_slip_12',
          permission: ['menu.payroll.scheme'],
          isHide: true
        }
      },
      {
        path: 'pay-send-results/:id',
        name: 'send-pay-slip',
        component: _import('payroll/pay-slip/pay-send-results'),
        meta: {
          module: '/payroll/pay-slip,payroll',
          type: '/payroll/pay-slip',
          title: 'pay_slip_21',
          permission: ['menu.payroll.scheme'],
          isHide: true
        }
      },
      // 工资条安全性
      {
        path: 'safe-pay-slip',
        name: '/payroll/safe-pay-slip',
        component: _import('payroll/pay-slip/safe-pay-slip/safe'),
        meta: {
          module: '/payroll/pay-slip,payroll',
          type: '/payroll/pay-slip', // 工资条 属于pay-slip二级路由下
          title: 'i18n.9bc68f8228ff4aa78c9d60a5e5de6056',
          permission: ['menu.payroll.scheme'],
          isHide: true
        }
      },
      // 工资条安全性历史记录
      {
        path: 'history-pay-slip',
        name: '/payroll/history-pay-slip',
        component: _import('payroll/pay-slip/safe-pay-slip/history'),
        meta: {
          module: '/payroll/safe-pay-slip,/payroll/pay-slip,payroll',
          type: '/payroll/safe-pay-slip',
          title: 'certificate_staff_9',
          permission: ['menu.payroll.scheme'],
          isHide: true
        }
      },
      {
        path: 'download-pay-slip',
        name: '/payroll/download-pay-slip',
        component: _import('payroll/pay-slip/download-pay-slip'),
        meta: {
          module: '/payroll/pay-slip,payroll',
          type: '/payroll/pay-slip',
          title: 'pay.slip.1',
          permission: ['menu.payroll.scheme'],
          isHide: true
        }
      }
    ]
  },
  // 证明下载
  {
    path: '/certificate',
    name: 'certificate',
    component: Layout,
    meta: {
      type: 'certificate',
      title: '1055',
      icon: 'certificate',
      permission: ['menu.certificate']
    },
    children: [
      {
        path: 'official',
        name: '/certificate/official',
        component: _import('certificate/official'),
        meta: {
          module: '/certificate/official,certificate',
          type: '/certificate/official',
          title: 'certificate_official_1',
          permission: ['menu.certificate.official']
        }
      },
      {
        path: 'detail-official/:state',
        name: '/certificate/detail-official',
        component: _import('certificate/official/detail'),
        meta: {
          module: '/certificate/official,certificate',
          type: '/certificate/official',
          title: 'certificate_official_1',
          // permission: ['menu.payroll.salary'],
          isHide: true
        }
      },
      // 员工证明
      {
        path: 'staff',
        name: '/certificate/staff',
        component: _import('certificate/staff'),
        meta: {
          module: '/certificate/staff,certificate',
          type: '/certificate/staff',
          title: '1860',
          permission: ['menu.certificate.staff']
        }
      },
      // 工资证明
      {
        path: 'detail-staff/:state',
        name: '/certificate/staff-detail',
        component: _import('certificate/staff/detail'),
        meta: {
          module: '/certificate/staff,certificate',
          type: '/certificate/staff',
          title: '1860',
          // permission: ['menu.payroll.salary'],
          isHide: true
        }
      },
      // 历史记录
      {
        path: 'history-staff',
        name: '/certificate/history-timing',
        component: _import('certificate/staff/history'),
        meta: {
          module: '/certificate/staff,certificate',
          type: '/certificate/staff',
          title: 'certificate_staff_9',
          // permission: ['menu.payroll.salary'],
          isHide: true
        }
      },
      // 定时发送
      {
        path: 'timing-staff',
        name: '/certificate/timing-staff',
        component: _import('certificate/staff/timing'),
        meta: {
          module: '/certificate/staff,certificate',
          type: '/certificate/staff',
          title: 'certificate_staff_10',
          // permission: ['menu.payroll.salary'],
          isHide: true
        }
      },
      // 定时发送查看
      {
        path: 'timing-staff-view/:state',
        name: '/certificate/timing-staff-view',
        component: _import('certificate/staff/detail'),
        meta: {
          module: '/certificate/timing-staff,/certificate/staff,certificate',
          type: '/certificate/timing-staff',
          title: '924',
          // permission: ['menu.payroll.salary'],
          isHide: true
        }
      },
      // 模版配置
      {
        path: 'mould',
        name: '/certificate/mould',
        component: _import('certificate/mould'),
        meta: {
          module: '/certificate/mould,certificate',
          type: '/certificate/mould',
          title: 'certificate_module_1',
          permission: ['menu.certificate.mould']
        }
      }
    ]
  },
  // 设置
  {
    path: '/settings',
    name: 'settings',
    type: 'settings',
    redirect: { name: 'settings_company_manager' },
    component: Layout,
    meta: { title: '63', icon: 'setting', permission: ['menu.settings'] },
    children: [
      // 企业管理
      {
        path: 'settings_company_manager',
        name: '/settings/settings_company_manager',
        component: _import('settings/company-manager'),
        meta: {
          module: '/settings/settings_company_manager,settings',
          type: '/settings/settings_company_manager',
          title: '311',
          permission: ['menu.settings.settings_company_manager']
        }
      },
      {
        path: 'author',
        name: 'author',
        component: _import('settings/author'),
        meta: {
          title: '339',
          permission: ['menu.settings.author']
        },
        children: [
          {
            path: 'authors',
            name: '/settings/author/authors',
            component: _import('settings/author/authors'),
            meta: {
              module: 'author,settings',
              type: '/settings/author/authors',
              title: '2001',
              permission: ['menu.settings.settings_company_manager']
            }
          },
          {
            path: 'authorsEdit',
            name: '/settings/author/authorsEdit',
            component: () => import('@/views/settings/author/authors/authors-edit'),
            meta: {
              module: '/settings/author/authors,author,settings', // 设置
              type: '/settings/author/authorsEdit', // 企业管理
              title: '342',
              permission: ['menu.settings.settings_company_manager'],
              isHide: true
            }
          },
          {
            path: 'orgView',
            name: '/settings/author/orgView',
            component: _import('settings/author/orgView'),
            meta: {
              module: 'author,settings',
              type: '/settings/author/orgView',
              title: '2002',
              permission: ['menu.settings.settings_company_manager']
            }
          }
        ]
      },
      // 安全设置
      {
        path: 'security',
        name: '/settings/security',
        component: _import('settings/security'),
        meta: {
          module: '/settings/security,settings',
          type: '/settings/security',
          title: '372',
          permission: ['menu.settings.security']
        }
      },
      {
        path: 'privacy-agreement',
        name: '/settings/privacy-agreement',
        component: _import('settings/privacy-agreement'),
        meta: {
          module: '/settings/privacy-agreement,settings',
          type: '/settings/privacy-agreement',
          title: 'i18n.1c1f025d7046470fbd564b227e97eb36',
          permission: ['menu.settings.privacy-agreement']
        }
      },
      // 操作日志
      {
        path: 'log',
        name: '/settings/log',
        component: _import('settings/log'),
        meta: {
          module: '/settings/log,settings',
          type: '/settings/log',
          title: 'i18n.e473bbb60a0048b4a58a89ef1b366ca1',
          permission: ['menu.settings.add_operation_log']
        }
      },
      // 邀请
      {
        path: 'invite',
        name: '/settings/invite',
        component: _import('settings/invite'),
        meta: {
          module: '/settings/invite,settings',
          type: '/settings/invite',
          title: '350',
          permission: ['menu.settings.invite']
        }
      }
      // {
      //   path: 'about',
      //   name: 'about',
      //   component: _import('settings/about'),
      //   meta: {
      //     title: '990',
      //     permission: ['menu.settings.invite']
      //   }
      // }
    ]
  },
  // 测试页面
  // {
  //   path: '/test',
  //   component: Layout,
  //   name: '1001',
  //   meta: { title: '测试', icon: 'org', permission: ['menu.org'] },
  //   children: [
  //     {
  //       path: 'index',
  //       name: '/test/index',
  //       component: _import('test'),
  //       meta: {
  //         title: '测试',
  //         icon: 'depart',
  //         permission: ['menu.org.dep'],
  //         isHide: process.env.NODE_ENV !== 'development'
  //       }
  //     }
  //   ]
  // },
  { path: '*', redirect: '/404', hidden: true }
]

export default asyncRoutes
